import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home/Home'
import about from '@/components/companyProfile/company'
import cooperation from "@/components/cooperation/cooperation"
import software from "@/components/software/software"
Vue.use(Router)


const  routes = [
    {
      path: '',
      name: 'home',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },
    {
      path: '/software',
      name: 'software',
      component: software
    }

  ]

const vuerote=new Router(
  {
    routes,
    mode:'hash'
  }
)

export default vuerote



// WEBPACK FOOTER //
// ./src/router/index.js